import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { PhotoType } from 'src/app/types/photo.type';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lv-photo-help',
  templateUrl: './photo-help.component.html',
  styleUrls: ['./photo-help.component.scss'],
  imports: [CommonModule, TranslateModule]
})
export class PhotoHelpComponent {
  @Input() photoType!: PhotoType;

  @ViewChild('summary') summary: ElementRef;

  get isFacePhoto(): boolean {
    return this.photoType === 'face';
  }

  get helpText(): string {
    return this.isFacePhoto ? 'verify-photo.component.photo-info' : 'verify-id.component.id-info';
  }

  onGotItClick() {
    this.summary.nativeElement.click();
  }
}
